<template>
	<div  id="page-panel">
		<resize-observer @notify="__resizeHanlder" />
		<div class="customer-top-nav no-print">

			<div class="title" v-if="inventory">
				<span>{{inventory.name}}</span> - {{$t("products.listTitle")}}<br>
				<span style="font-size:14px;">{{inventory.description}}</span>
			</div>
			<div class="controls">
				<el-radio-group v-model="modeModel" class="hidden-sm-and-down" size="small">
					<el-radio-button label="list" style="padding:5px 0px 5px 0px;"><i class="mdi mdi-view-list" style="font-size:12px;"></i></el-radio-button>
					<el-radio-button label="tile" style="padding:5px 0px 5px 0px;"><i class="mdi mdi-view-grid" style="font-size:12px;"></i></el-radio-button>
				</el-radio-group>
        <el-button-group class="hidden-sm-and-down" >
          <el-button type="primary" size="small" :disabled="!$can('manage', 'Inventories') || !canManageInventories" @click="handleAddInventoryProduct"><i class="mdi mdi-plus-circle"><span class="pl-5">{{$t('common.Add')}}</span></i> </el-button>
          <el-button type="primary"size="small"  icon="el-icon-s-tools"  @click="optionsVisible=true"></el-button>
		  <el-button type="primary" size="small" class="mdi mdi-chart-box"  @click="inventoryReportDrawerVisible=true"></el-button>
        </el-button-group>

			</div>

		</div>
		<el-row>
      <el-col :span="itemListSpan">
				<!-- product list -->
				<InventoryProductList @open="openProduct" :products="products"></InventoryProductList>
			</el-col>
			<el-col :span="itemDetailSpan" v-if="showItem" >
				<!-- product detail -->
				<InventoryProductDetail :product="selectedProduct" @refresh="handleRefresh" :inventoryId="inventoryId" @close="closeProduct" @editItem="editItem"></InventoryProductDetail>
			</el-col>
		</el-row>
		<el-row>
		<ProductDetailDrawer :puid="selectedPuid" :inventoryId="inventoryId" direction="rtl" :visible="productDetailDrawerVisible" @close="closeProductDetailDrawer" @editItem="editItem"></ProductDetailDrawer>
    	<InventoryOptionsDrawer :visible="optionsVisible" :inventoryId="inventoryId" @close="optionsVisible=false"></InventoryOptionsDrawer>
		<InventoryReportDrawer :visible="inventoryReportDrawerVisible" :inventoryId="inventoryId" @close="inventoryReportDrawerVisible=false"> </InventoryReportDrawer>
		<ItemDrawer :visible="itemDrawerVisible" :inventory="inventory" @close="closeItemDrawer" @add="handleAddItem" :edit="itemToEdit" @update="handleUpdateItem"></ItemDrawer>
		</el-row>
	</div>
</template>

<script>
import ProductDetailDrawer from '@/views/pages/inventory/components/product-detail-drawer'
import InventoryProductList from './components/inventory-product-list'
import InventoryProductDetail from './components/product-detail'
import InventoryOptionsDrawer from '@/components/inventory/inventory-options-drawer'
import InventoryReportDrawer from '@/components/inventory/inventory-report-drawer'
import ItemDrawer from '@/components/product/item-drawer'
import { mapActions, mapState, mapGetters } from 'vuex';

export default {
  data() {
    return {
			poDialogVisible : false,
			itemListSpan : 24,
      itemDetailSpan:0,
			showItem : true,
			optionsVisible:false,
			pageWidth : 0,
			pageHeight : 0,
			productDetailDrawerVisible : false,
			selectedPuid : null,
			itemDrawerVisible : false,
			itemToEdit : null,
			inventoryReportDrawerVisible : false,
    };
  },components: {
		// InventoryProductTable: () => import('./components/inventory-product-table'),
		InventoryProductList,
		InventoryProductDetail,
		InventoryOptionsDrawer,
		ProductDetailDrawer,
		ItemDrawer,
		InventoryReportDrawer,
  },
	methods: {
		editItem(itemToEdit){
			this.itemToEdit =itemToEdit;
			this.openItemDrawer();
		},
		handleAddItem(itemAdded){
      this.invalidateProductList();
	    this.fetchSearchedProducts();
		},
		handleUpdateItem(itemUpdated){
			this.handleRefresh();
		},
		openItemDrawer(){this.itemDrawerVisible = true},
		closeItemDrawer(){this.itemDrawerVisible = false; this.itemToEdit = null;},
		closeProductDetailDrawer(){
			this.productDetailDrawerVisible = false;
		},
		openProductDetailDrawer(puid){
			this.selectedPuid = puid;
			this.productDetailDrawerVisible = true;
		},
		handleRefresh(){
			this.updateSelectedProduct()
		},
    openProduct(product,index){
			if(this.mode=='tile'){
				this.activeTabs = 'overview';
				if(this.pageWidth<1054){
	        this.itemListSpan=0;
	        this.itemDetailSpan = 24;
	      }else{
	        this.itemListSpan=8;
	        this.itemDetailSpan=16;
	      }
	      this.showItem=true;

	      this.active_el = product.id;
	      this.setSelectedProduct({index:index,selectedProduct:product})
			}else{
				this.openProductDetailDrawer(product.puid)
			}

    },
    close(){
			this.$router.go(-1);
		},
		closeProduct(){
			this.itemDetailSpan=0;
			this.itemListSpan=24;
			this.showItem=false;
		},
		setPageWidth() {
			this.pageWidth = document.getElementById('page-panel').offsetWidth;
			this.pageHeight = document.getElementById('page-panel').offsetHeight;
		},
    __resizeHanlder: _.throttle(function (e) {
			this.setPageWidth();
		}, 700),
		handleAddInventoryProduct(){
			this.openItemDrawer();
		},
		...mapActions('inventoryProducts', ['initInventoryProducts','fetchSearchedProducts','setSelectedProduct','changeMode','updateSelectedProduct', 'invalidateProductList'])
	},
	computed: {
		canManageInventories () {
			return _.get(this.inventory, 'code') !== 'SAQ_AUTO';
		},
		inventoryId(){
			return parseInt(this.$route.params.id);
		},
		modeModel : {
			get(){ return this.mode},
			set(mode){this.closeProduct();this.changeMode(mode)}
		},
		...mapState('inventoryProducts', ['inventory','products', 'selectedProduct','selectedIndex','mode'])
	},
	watch : {
		inventoryId : function(val, oldVal){
			this.closeProduct();
			this.initInventoryProducts(val);
			this.fetchSearchedProducts();
		}
	},
	mounted(){
		this.setPageWidth();
	},
	created(){

		this.initInventoryProducts(this.inventoryId);
    this.fetchSearchedProducts();
	}
}
</script>

<style lang="scss" scoped>
@import '../../../assets/scss/_variables';


.title {
	font-size : 1.6em;
	font-weight:bold;
	margin-right:20px;
	position:relative;
	float:left;
}
.customer-top-nav{
  height:80px;
}

.controls{
	position:relative;
	float:right;

	button{
		margin-left:20px;
	}
}

.el-table tr, .el-table__row{
  background-color: #f3f7fa;
}


@media (max-width: 1024px) {
  img.inventory {
    margin-top:20px;
    height:175px;
  }
  .customer-top-nav {
    text-align:center;
    height: auto;
    margin-bottom: 5px;
    width:100%;
  }
  .title {
  	font-size : 1em;
  	font-weight:bold;
    width:100%;
  }

  .view {
    padding:0px;
  }
}
</style>
